module.exports = __webpack_public_path__ + "static/media/multimodalimage.ca6808fb.png";